import * as React from "react";
import Box from "@mui/material/Box";

export default function Flex({ children, ...props }) {
  return <Box sx={{ display: "flex", ...props }}>{children}</Box>;
}
